import { LIMIT } from '@/constants';
import { fetcher } from '@/services/graphql/fetcher/index';
import { AfterSaleState, Sort, type AnyObj } from '@/types';
import {
  fetchAfterSaleByAfterSaleIdDocument,
  fetchAfterSaleByOrderIdDocument,
  fetchAfterSaleCustomerReceiptDocument,
  fetchAfterSalesListDocument,
  fetchCancelAfterSaleDocument,
  fetchCommdityGetRefundableAmountDocument,
  fetchCreateAfterSaleDocument,
  fetchFillOutReturnLogisticsDocument,
  fetchGetRefundableAmountDocument,
  fetchShoppingCreditsClaimAndDeductionAmountDocument,
  fetchUpdateAfterSaleDocument,
  fetchUpdateReturnLogisticsDocument,
} from '../graphql/docs';

export const fetchAfterSalesList = async (skip: number) => {
  const res = await fetcher.query(fetchAfterSalesListDocument, {
    variables: {
      options: {
        skip: LIMIT * skip,
        take: LIMIT,
        sort: {
          createdAt: Sort.DESC,
        },
        filter: {
          // state: { notIn: [AfterSaleState.successfulRefund, AfterSaleState.cancel] },
        },
      },
    },
  });
  return res.data.value?.afterSales.items;
};

/**
 * 根据订单id查询售后列表信息
 * @param orderId - 订单id
 * @returns
 */
export const fetchAfterSaleByOrderId = async (orderId: string) => {
  const res = await fetcher.mutation(fetchAfterSaleByOrderIdDocument, {
    orderId,
    options: {
      filter: {
        state: {
          notEq: AfterSaleState.cancel,
        },
      },
    },
  });
  return res.data?.afterSaleByOrderId?.items;
};

/**
 * 根据售后id查询售后信息
 * @param afterSaleId - 售后id
 * @returns
 */
export const fetchAfterSaleByAfterSaleId = async (afterSaleId: string) => {
  const res = await fetcher.mutation(fetchAfterSaleByAfterSaleIdDocument, {
    afterSaleId,
  });
  return res.data?.afterSale;
};

/**
 * 撤销售后
 * @param afterSaleId - 售后id
 * @returns
 */
export const fetchCancelAfterSale = async (afterSaleId: string) => {
  const res = await fetcher.mutation(fetchCancelAfterSaleDocument, {
    afterSaleId,
  });
  return res.data?.cancelAfterSale;
};

/**
 * 申请售后
 * @param input
 * @returns
 */
export const fetchCreateAfterSale = async (input: AnyObj) => {
  const res = await fetcher.mutation(fetchCreateAfterSaleDocument, {
    input,
  });
  return res.data?.createAfterSale;
};

/**
 * 修改售后申请
 * @param input
 * @returns
 */
export const fetchModifyAfterSale = async (input: AnyObj) => {
  const res = await fetcher.mutation(fetchUpdateAfterSaleDocument, {
    input,
  });
  return res.data?.updateAfterSale;
};

/**
 * 换货确认收货
 * @param afterSaleId - 售后id
 */
export const fetchAfterSaleCustomerReceipt = async (afterSaleId: string) => {
  const res = await fetcher.mutation(fetchAfterSaleCustomerReceiptDocument, {
    afterSaleId,
  });
  return res.data?.afterSaleCustomerReceipt;
};

/**
 * 填写退换货物流
 * @param variables
 */
export const fetchInputLogistics = async (variables: AnyObj) => {
  const res = await fetcher.mutation(fetchFillOutReturnLogisticsDocument, variables);
  return res.data?.fillOutReturnLogistics;
};

/**
 * 修改物流
 * @param variables
 */
export const fetchUpdateReturnLogistics = async (variables: AnyObj) => {
  const res = await fetcher.mutation(fetchUpdateReturnLogisticsDocument, variables);
  return res.data?.updateReturnLogistics;
};

/**
 * 获取最大可退款金额
 * @param variables
 * @returns
 */
export const fetchGetRefundableAmount = async (
  orderId: string,
  lineIds: string[],
  isInclusionShippingPrice: boolean,
  isUpdate: boolean
) => {
  const res = await fetcher.query(fetchGetRefundableAmountDocument, {
    variables: {
      orderId,
      lineIds,
      isInclusionShippingPrice,
      isUpdate,
    },
  });
  return res.data.value?.getRefundableAmount;
};

// 获取单个商品的可退金额
export const fetchCommdityRefunableAmount = async (orderId: string) => {
  const res = await fetcher.query(fetchCommdityGetRefundableAmountDocument, {
    variables: {
      orderId,
    },
  });
  return res.data.value?.getRefundableAmountByOrderId;
};

/**
 * 获取购物金抵扣和返还金额
 * @param orderId - 订单id
 * @returns
 */
export const fetchShoppingCreditsClaimAndDeductionAmount = async (orderId: string) => {
  const res = await fetcher.query(fetchShoppingCreditsClaimAndDeductionAmountDocument, {
    variables: {
      orderId,
    },
  });
  return res.data.value?.shoppingCreditsClaimAndDeductionAmount;
};
